/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BookedHoursForEmployees } from '../models/BookedHoursForEmployees';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingBookedHoursService {
    /**
     * lists booked hours
     * @param tenantId tenant_id
     * @param startDate start_date
     * @param endDate end_date
     * @returns BookedHoursForEmployees successful
     * @throws ApiError
     */
    public static getBookedHours(
        tenantId: string,
        startDate: string,
        endDate: string,
    ): CancelablePromise<BookedHoursForEmployees> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/booked_hours',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
    /**
     * exports booked hours
     * @param tenantId tenant_id
     * @param startDate start_date
     * @param endDate end_date
     * @returns binary successful
     * @throws ApiError
     */
    public static export(
        tenantId: string,
        startDate: string,
        endDate: string,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/booked_hours/export',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
            },
        });
    }
}
